import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBookIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 11 13",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		d: "M2.35714 0C1.0558 0 0 1.0918 0 2.4375V10.5625C0 11.9082 1.0558 13 2.35714 13H9.42857H10.2143C10.6489 13 11 12.6369 11 12.1875C11 11.7381 10.6489 11.375 10.2143 11.375V9.75C10.6489 9.75 11 9.38691 11 8.9375V0.8125C11 0.363086 10.6489 0 10.2143 0H9.42857H2.35714ZM2.35714 9.75H8.64286V11.375H2.35714C1.92254 11.375 1.57143 11.0119 1.57143 10.5625C1.57143 10.1131 1.92254 9.75 2.35714 9.75ZM3.14286 3.65625C3.14286 3.43281 3.31964 3.25 3.53571 3.25H8.25C8.46607 3.25 8.64286 3.43281 8.64286 3.65625C8.64286 3.87969 8.46607 4.0625 8.25 4.0625H3.53571C3.31964 4.0625 3.14286 3.87969 3.14286 3.65625ZM3.53571 4.875H8.25C8.46607 4.875 8.64286 5.05781 8.64286 5.28125C8.64286 5.50469 8.46607 5.6875 8.25 5.6875H3.53571C3.31964 5.6875 3.14286 5.50469 3.14286 5.28125C3.14286 5.05781 3.31964 4.875 3.53571 4.875Z",
		fill: "currentColor"
	}) })
});
export default SvgBookIcon;
